import React from 'react';
import { OauthApplicationDetails } from '../components/OauthApplications';

export default function OauthApplication() {
  return <OauthApplicationDetails />;
}
